<template lang="pug">
#permitted-function-list(v-cloak)
  //- 使用機能の目次
  .box.box-margin
    .box-header.with-border.register-header
      .title
        span 家族の使用機能
      .buttons
        button.btn.edit-btn(v-if="_showEditButton" @click="gotoPermittedFunctionEdit" type="button") 使用機能の変更
    .box-body.register-body
      .message.mb-2(v-if="_showEditButton")
        span 各機能の使用設定を変更したい場合は、右上の使用機能の変更からご変更ください。
      .message.mb-2(v-else)
        span 各機能の使用設定を変更したい場合は、管理者ユーザーで設定変更してください。
      //- 目次を表示する
      .function-list.d-flex.flex-column.align-items-center
        .content.d-flex.flex-row.align-items-center(v-for="item in permittedFunctionItems")
          .icon.d-flex.flex-column.align-items-center
            img(:src="item.iconUrl")
            span.used(v-if="item.permitted == true") 使用中
            span.unused(v-else) 未使用
          .function.flex-grow-1
            .title {{ item.title }}
            .text {{ item.text }}
          .buttons.d-flex.flex-row-reverse
            button.btn.link-btn(v-scroll-to="item.linkUrl") 機能詳細
  //- 使用機能の詳細説明
  .box
    .box-body.register-body
      .function-detail-list.d-flex.flex-column.align-items-center
        .content.d-flex.flex-column(v-for="item in permittedFunctionItems" :id="item.id")
          //- アイコンとタイトル
          .icon.d-flex.align-items-center
            img.icon-image(:src="item.iconUrl")
            span.title {{ item.title }}
          //- 詳細説明のコンテンツは改行や文字色を部分的に変更するなど、自由にデザインを作りたいのでidで分岐して自由にhtmlを記載する
          .description
            //- 家族からの連絡
            .opinion(v-if="item.id == 'opinion'")
              .d-flex.flex-row
                .images
                  img(src="@/assets/permitted-function-opinion.png")
                .text.flex-grow-1
                  span
                    strong ■ 特徴
                    ul
                      li
                        span 家族は
                        span.key-phrase いつでも簡単
                        span にLINEから連絡できます。
                      li
                        span 家族からの
                        span.key-phrase 電話が減り
                        span 、回答もメッセージで出来るので、
                        span.key-phrase 施設職員の負担も軽減
                        span されます。
                      li
                        span.key-phrase 家族から感謝
                        span のメッセージも多く届くので、
                        span.key-phrase 職員のモチベーションアップ
                        span にもなります。
                  span
                    strong ■ 機能
                    ul
                      li
                        span 家族は連絡機能を使用して、施設に連絡を送ることが出来ます（記名もしくは匿名）。
                      li
                        span 管理システムの受信メッセージで家族からの連絡を確認し、返信することが出来ます。
                    span ※ 家族は通常のLINEのトークではなく、HitomeQコネクトの連絡機能を使用します。
            //- 訪問面会予約
            .reservation(v-if="item.id == 'reservation'")
              .d-flex.flex-row
                .images
                  img(src="@/assets/permitted-function-reservation.png")
                .text.flex-grow-1
                  span
                    strong ■ 特徴
                    ul
                      li
                        span 家族は
                        span.key-phrase いつでも簡単
                        span にLINEから予約できます。
                      li
                        span 予約時の
                        span.key-phrase 電話対応時間を削減
                        span 出来ます。
                      li
                        span 窓越し面会や面会室での面会など、
                        span.key-phrase 面会制限に合わせて予約設定
                        span することが出来ます。
                  span
                    strong ■ 機能
                    ul
                      li
                        span 施設での運用に合わせて、同時面会可能数や面会時間などの基本設定ができます。
                      li
                        span 施設で面会可能なスケジュールを設定できます（フロアごとに設定することも出来ます）。
                      li
                        span 家族は面会予約機能でスケジュールを確認し、予約申込みすることが出来ます。
            //- オンライン面会
            .online-reservation(v-if="item.id == 'online-reservation'")
              .d-flex.flex-row
                .images
                  img(src="@/assets/permitted-function-online-reservation.png")
                .text.flex-grow-1
                  span
                    strong ■ 特徴
                    ul
                      li
                        span 施設も家族も特別なオンライン面会ツールの
                        span.key-phrase インストールが不要
                        span です。
                      li
                        span 家族は予約完了メッセージから
                        span.key-phrase ワンタップ
                        span でオンライン面会を開始出来ます。
                      li
                        span 家族が簡単に使えるので、
                        span.key-phrase 多くの家族が使用
                        span 出来ます。
                      li
                        span 予約時の
                        span.key-phrase 電話対応時間を削減
                        span 出来ます。
                  span
                    strong ■ 機能
                    ul
                      li
                        span 施設での運用に合わせて、同時面会可能数や面会時間などの基本設定ができます。
                      li
                        span 施設で面会可能なスケジュールを設定できます（フロアごとに設定することも出来ます）。
                      li
                        span 家族は面会予約機能からスケジュールを確認し、予約申込みすることが出来ます。
                      li
                        span 家族４人まで同時にビデオ通話に参加することが出来ます。
            //- 外出外泊届け
            .online-reservation(v-if="item.id == 'outing'")
              .d-flex.flex-row
                .images
                .text.flex-grow-1
                  span
                    strong ■ 特徴
                    ul
                      li
                        span 家族は
                        span.key-phrase いつでも簡単
                        span にLINEから届出を申請できます。
                    ul
                      li
                        span 申請時に外出先や食事の有無も登録できます。
                    ul
                      li
                        span LINEを使えない家族の場合は
                        span.key-phrase 施設で代理申請
                        span ができます。
                  span
                    strong ■ 機能
                    ul
                      li
                        span 施設での運用に合わせて、外出可能な曜日や時間の設定ができます。
                      li
                        span 家族は外出外泊届け機能からスケジュールを確認して申請できます。
                      li
                        span 施設では申請内容を確認して承諾もしくは辞退の対応ができます。
            //- イベント情報
            .event(v-if="item.id == 'event'")
              .d-flex.flex-row
                .images
                  img(src="@/assets/permitted-function-event.png")
                .text.flex-grow-1
                  span
                    strong ■ 特徴
                    ul
                      li
                        span 家族はLINEから施設のイベント情報を
                        span.key-phrase いつでも見ることが出来ます。
                      li
                        span 家族訪問
                        span.key-phrase イベントを開催できなくても
                        span 、家族向けに
                        span.key-phrase ライブ配信
                        span できます。
                      li
                        span 施設利用者が
                        span.key-phrase 施設で楽しく生活
                        span していることが分かるので、
                        span.key-phrase 家族が安心
                        span します。
                  span
                    strong ■ 機能
                    ul
                      li
                        span 管理システムでイベント情報（内容・日時・場所・画像）を作成し、家族に公開できます。
                      li
                        span 現地開催もしくはオンライン開催を設定し、家族がLINEから参加申込みできます。
                      li
                        span オンライン開催の場合は、イベントをライブ配信し、家族が視聴することが出来ます。
            //- 介護記録
            .careimage(v-if="item.id == 'careimage'")
                .d-flex.flex-row
                .images
                  img(src="@/assets/permitted-function-careimage.png")
                .text.flex-grow-1
                  span
                    strong ■ 特徴
                    ul
                      li
                        span 家族は日々の介護記録を見ることで、
                        span.key-phrase 施設利用者の状態が分かるので安心
                        span 出来ます。
                      li
                        span 家族が利用者の状態を理解することで、
                        span.key-phrase 家族とのコミュニケーションがスムーズ
                        span になります。
                      li
                        span 介護記録公開により家族からの信頼が高まり、施設内でアクシデントが起こった場合も
                        span.key-phrase 家族とトラブルになりにくい。
                  span
                    strong ■ 機能
                    ul
                      li
                        span 管理システムの介護記録から、利用者ごと、日にちごとに介護記録（画像ファイルもしくはPDFファイル）を登録することが出来ます。
                      li
                        span 介護記録を公開すると、家族のLINEに公開通知が自動配信されます。
                      li
                        span 家族は公開されている介護記録をLINEから見ることが出来ます。
                    span ※ 介護記録を記録する機能ではありません。記録済みの介護記録を家族に提供する機能です。
            //- 写真印刷依頼（家族からの写真送付）
            .picture(v-if="item.id == 'picture'")
                .d-flex.flex-row
                .images
                  img(src="@/assets/permitted-function-picture.png")
                .text.flex-grow-1
                  span
                    strong ■ 特徴
                    ul
                      li
                        span 写真と合わせてメッセージを送ることが出来るので、
                        span.key-phrase 家族から施設利用者への気持ちを伝える
                        span ことが出来ます。
                      li
                        span 家族から送られた写真は、メッセージ・依頼者名と合わせて
                        span.key-phrase 簡単に印刷
                        span することが出来ます。
                  span
                    strong ■ 機能
                    ul
                      li
                        span 家族は送付する写真を選択し、メッセージと合わせて送ることが出来ます。
                      li
                        span 施設では送られてきた写真を印刷することが出来ます。
          //- 上に戻るボタン
          .buttons.d-flex.flex-row-reverse
            button.btn.link-btn(v-scroll-to="'#permitted-function-list'") 上に戻る

  PageLoading(:isBusy="isBusy" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";
import { Getter } from "vuex-class";

import { PermittedFunctions } from "@/commons/services/Facilities";
import { PcUrl } from "@/commons/constants/PcUrl";
import { Account } from "@/commons/services/Authorization";

import PageLoading from "@/pc/basics/PageLoading.vue";
import FormLabel from "@/pc/components/forms/FormLabel.vue";

/**
 * 使用機能の確認画面コンポーネント
 */
@Component({
  components: {
    FormLabel,
    PageLoading
  }
})
export default class PermittedFunctionList extends Vue {
  /** ユーザー名。ユーザー情報修正画面で更新されるので、storeのgetterから値を取得する */
  @Getter("user") user!: Account;

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";

  /** 機能使用可否 */
  permittedFunctions: PermittedFunctions = {
    careimage: false,
    opinion: false,
    reservation: false,
    onlineReservation: false,
    outing: false,
    picture: false,
    event: false,
    otherUserOpinion: false,
    waiterOpinion: false
  };

  /** 機能使用可否各行の情報 */
  permittedFunctionItems: Array<PermittedFunctionListItem> = [];

  get _showEditButton(): boolean {
    return userStore.user.permissions.functions.useFamilyFunctionsFunction;
  }

  /**
   * ### vue lifecycle mounted
   */
  public async mounted(): Promise<void> {
    await this.createView();

    return;
  }

  /**
   * ### 画面情報作成
   */
  public async createView(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    // 機能の使用可否をstoreから取得する
    this.permittedFunctions = userStore.facility.permittedFunctions;

    // 機能の使用可否から目次の情報を作成する
    // 画像のURL等、保持していない情報が多いのでfor文等は使用できない
    this.permittedFunctionItems = [
      {
        id: "opinion",
        permitted: this.permittedFunctions.opinion,
        iconUrl: require("../../../assets/permitted-function-opinion-icon.png"),
        title: "家族からの連絡",
        text: "家族から施設に連絡・問い合わせが出来ます。施設では内容の確認と返信が出来ます。",
        linkUrl: "#opinion"
      },
      {
        id: "reservation",
        permitted: this.permittedFunctions.reservation,
        iconUrl: require("../../../assets/permitted-function-reservation-icon.png"),
        title: "訪問面会予約",
        text: "家族が施設訪問の予約を出来ます。施設では面会スケジュール等の設定が出来ます。",
        linkUrl: "#reservation"
      },
      {
        id: "online-reservation",
        permitted: this.permittedFunctions.onlineReservation,
        iconUrl: require("../../../assets/permitted-function-reservation-icon.png"),
        title: "オンライン面会",
        text: "家族と施設でビデオ通話できます。家族は面会予約、施設は面会スケジュール等の設定が出来ます。",
        linkUrl: "#online-reservation"
      },
      {
        id: "outing",
        permitted: this.permittedFunctions.outing,
        iconUrl: require("../../../assets/permitted-function-outing-icon.png"),
        title: "外出外泊届け",
        text: "家族が外出／外泊届けを申請できます。施設は曜日や時間などの設定ができます。",
        linkUrl: "#outing"
      },
      {
        id: "event",
        permitted: this.permittedFunctions.event,
        iconUrl: require("../../../assets/permitted-function-event-icon.png"),
        title: "イベント情報",
        text: "家族へイベント案内し、家族は参加申込みが出来ます。オンラインのライブ配信も出来ます。",
        linkUrl: "#event"
      },
      {
        id: "careimage",
        permitted: this.permittedFunctions.careimage,
        iconUrl: require("../../../assets/permitted-function-careimage-icon.png"),
        title: "介護記録",
        text: "介護記録（画像もしくはPDF）を登録・公開すると、家族がLINEから見ることが出来ます。",
        linkUrl: "#careimage"
      },
      {
        id: "picture",
        permitted: this.permittedFunctions.picture,
        iconUrl: require("../../../assets/permitted-function-picture-icon.png"),
        title: "写真印刷依頼（家族からの写真送付）",
        text: "家族が施設利用者（入居者）に見せたい写真をメッセージ付きで送ることが出来ます。",
        linkUrl: "#picture"
      }
    ];

    this.isBusy = false;

    return;
  }

  /** 家族の使用機能の変更画面へ遷移する */
  public gotoPermittedFunctionEdit(): void {
    this.$router.push(PcUrl.PermittedFunctionEdit);
    return;
  }
}

interface PermittedFunctionListItem {
  /** ページ内リンク用のID */
  id: string;
  /** 機能の使用可否 */
  permitted: boolean;
  /** アイコン画像URL */
  iconUrl: string;
  /** 機能名 */
  title: string;
  /** 機能説明文 */
  text: string;
  /** ページ内リンクURL */
  linkUrl: string;
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

// 親要素からネストしてスタイルを指定する
#permitted-function-list {
  max-width: 980px;
  margin-left: auto;
  margin-right: auto;

  .edit-btn {
    width: 160px;
  }

  .message {
    padding: 0 0 10px 10px;
  }

  // 使用機能の目次
  .function-list {
    width: 100%;

    .content {
      width: 100%;
      padding-top: 5px;
      padding-bottom: 5px;
      padding-left: 11px;
      padding-right: 11px;
      margin-bottom: 15px;
      border-bottom: solid 1px #cccccc;
      // アイコン
      .icon {
        min-width: 60px;
        width: 60px;
        margin-right: 12px;
        // 使用中・未使用
        .used,
        .unused {
          font-weight: bold;
        }
        .used {
          color: $font-key-color;
        }
        .unused {
          color: $font-disable-font-color;
        }
      }
      // 機能名
      .function {
        margin-right: 12px;
        .title {
          font-size: 18px;
          font-weight: bold;
        }
      }
      // 機能詳細ボタン
      .buttons {
        width: 110px;

        .link-btn {
          width: 100px;
        }
      }
    }
    .content:last-child {
      border-bottom: 0;
      margin-bottom: 0;
    }
  }

  // 使用機能の詳細説明
  .function-detail-list {
    width: 100%;

    .content {
      width: 100%;
      padding-top: 0px;
      padding-bottom: 5px;
      padding-left: 11px;
      padding-right: 11px;
      margin-bottom: 15px;
      border-bottom: solid 1px #cccccc;
      // アイコンとタイトル
      .icon {
        margin-bottom: 12px;

        .icon-image {
          margin-right: 12px;
        }
        .title {
          font-size: 18px;
          font-weight: bold;
        }
      }
      // 詳細説明のコンテンツ
      .description {
        margin-bottom: 15px;
        // 画像
        .images {
          width: 200px;
          margin-right: 15px;

          img {
            width: 200px;
          }
        }
        // 詳細説明テキスト
        .text {
          .key-phrase {
            font-weight: bold;
            color: $font-key-color;
          }
        }
      }
      // 上に戻るボタン
      .buttons {
        width: 100%;
        margin-bottom: 7px;
      }
    }
    .content:last-child {
      border-bottom: 0;
      margin-bottom: 0;
    }
  }
}
</style>
